"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSelectedUpsellVariant = exports.setSlidersValues = exports.setProductRelationshipCategories = exports.setIsConnectivityPlanSelected = exports.setConnectivityPlan = exports.removeSelectedUpsellProduct = exports.removeDisplayedUpsellProductDetails = exports.goBackToRecommendation = exports.clearSlidersValues = exports.clearSelectedUpsellProducts = exports.addSelectedUpsellProduct = exports.addDisplayedUpsellProductDetails = exports.UPDATE_SELECTED_UPSELL_VARIANT = exports.SET_UPSELL_CATEGORIES = exports.SET_SLIDERS_VALUES = exports.SET_IS_CONNECTIVITY_PLAN_SELECTED = exports.SET_CONNECTIVITY_PLAN = exports.REMOVE_SELECTED_UPSELL_PRODUCT = exports.REMOVE_DISPLAYED_UPSELL_PRODUCT_DETAILS = exports.GO_BACK_TO_RECOMMENDATION = exports.CLEAR_SLIDERS_VALUES = exports.CLEAR_SELECTED_UPSELL_PRODUCT = exports.ADD_SELECTED_UPSELL_PRODUCT = exports.ADD_DISPLAYED_UPSELL_PRODUCT_DETAILS = void 0;
var GO_BACK_TO_RECOMMENDATION = 'GO_BACK_TO_RECOMMENDATION';
exports.GO_BACK_TO_RECOMMENDATION = GO_BACK_TO_RECOMMENDATION;
var SET_UPSELL_CATEGORIES = 'SET_UPSELL_CATEGORIES';
exports.SET_UPSELL_CATEGORIES = SET_UPSELL_CATEGORIES;
var ADD_SELECTED_UPSELL_PRODUCT = 'ADD_SELECTED_UPSELL_PRODUCT';
exports.ADD_SELECTED_UPSELL_PRODUCT = ADD_SELECTED_UPSELL_PRODUCT;
var REMOVE_SELECTED_UPSELL_PRODUCT = 'REMOVE_SELECTED_UPSELL_PRODUCT';
exports.REMOVE_SELECTED_UPSELL_PRODUCT = REMOVE_SELECTED_UPSELL_PRODUCT;
var CLEAR_SELECTED_UPSELL_PRODUCT = 'CLEAR_SELECTED_UPSELL_PRODUCT';
exports.CLEAR_SELECTED_UPSELL_PRODUCT = CLEAR_SELECTED_UPSELL_PRODUCT;
var UPDATE_SELECTED_UPSELL_VARIANT = 'UPDATE_SELECTED_UPSELL_VARIANT';
exports.UPDATE_SELECTED_UPSELL_VARIANT = UPDATE_SELECTED_UPSELL_VARIANT;
var ADD_DISPLAYED_UPSELL_PRODUCT_DETAILS = 'ADD_DISPLAYED_UPSELL_PRODUCT_DETAILS';
exports.ADD_DISPLAYED_UPSELL_PRODUCT_DETAILS = ADD_DISPLAYED_UPSELL_PRODUCT_DETAILS;
var REMOVE_DISPLAYED_UPSELL_PRODUCT_DETAILS = 'REMOVE_DISPLAYED_UPSELL_PRODUCT_DETAILS';
exports.REMOVE_DISPLAYED_UPSELL_PRODUCT_DETAILS = REMOVE_DISPLAYED_UPSELL_PRODUCT_DETAILS;
var SET_CONNECTIVITY_PLAN = 'SET_CONNECTIVITY_PLAN';
exports.SET_CONNECTIVITY_PLAN = SET_CONNECTIVITY_PLAN;
var SET_IS_CONNECTIVITY_PLAN_SELECTED = 'SET_IS_CONNECTIVITY_PLAN_SELECTED';
exports.SET_IS_CONNECTIVITY_PLAN_SELECTED = SET_IS_CONNECTIVITY_PLAN_SELECTED;
var SET_SLIDERS_VALUES = 'SET_SLIDERS_VALUES';
exports.SET_SLIDERS_VALUES = SET_SLIDERS_VALUES;
var CLEAR_SLIDERS_VALUES = 'CLEAR_SLIDERS_VALUES';
exports.CLEAR_SLIDERS_VALUES = CLEAR_SLIDERS_VALUES;
var goBackToRecommendation = function goBackToRecommendation() {
  return {
    type: GO_BACK_TO_RECOMMENDATION
  };
};
exports.goBackToRecommendation = goBackToRecommendation;
var setProductRelationshipCategories = function setProductRelationshipCategories(upsellProductCategories) {
  return {
    type: SET_UPSELL_CATEGORIES,
    payload: {
      upsellProductCategories: upsellProductCategories
    }
  };
};
exports.setProductRelationshipCategories = setProductRelationshipCategories;
var addSelectedUpsellProduct = function addSelectedUpsellProduct(id, category) {
  return {
    type: ADD_SELECTED_UPSELL_PRODUCT,
    payload: {
      id: id,
      category: category
    }
  };
};
exports.addSelectedUpsellProduct = addSelectedUpsellProduct;
var removeSelectedUpsellProduct = function removeSelectedUpsellProduct(id, category) {
  return {
    type: REMOVE_SELECTED_UPSELL_PRODUCT,
    payload: {
      id: id,
      category: category
    }
  };
};
exports.removeSelectedUpsellProduct = removeSelectedUpsellProduct;
var clearSelectedUpsellProducts = function clearSelectedUpsellProducts() {
  return {
    type: CLEAR_SELECTED_UPSELL_PRODUCT
  };
};
exports.clearSelectedUpsellProducts = clearSelectedUpsellProducts;
var updateSelectedUpsellVariant = function updateSelectedUpsellVariant(variant, productId) {
  return {
    type: UPDATE_SELECTED_UPSELL_VARIANT,
    payload: {
      variant: variant,
      productId: productId
    }
  };
};
exports.updateSelectedUpsellVariant = updateSelectedUpsellVariant;
var addDisplayedUpsellProductDetails = function addDisplayedUpsellProductDetails(product) {
  return {
    type: ADD_DISPLAYED_UPSELL_PRODUCT_DETAILS,
    payload: {
      product: product
    }
  };
};
exports.addDisplayedUpsellProductDetails = addDisplayedUpsellProductDetails;
var removeDisplayedUpsellProductDetails = function removeDisplayedUpsellProductDetails(product) {
  return {
    type: REMOVE_DISPLAYED_UPSELL_PRODUCT_DETAILS,
    payload: {
      product: product
    }
  };
};
exports.removeDisplayedUpsellProductDetails = removeDisplayedUpsellProductDetails;
var setConnectivityPlan = function setConnectivityPlan(product) {
  return {
    type: SET_CONNECTIVITY_PLAN,
    payload: {
      product: product
    }
  };
};
exports.setConnectivityPlan = setConnectivityPlan;
var setIsConnectivityPlanSelected = function setIsConnectivityPlanSelected(selected) {
  return {
    type: SET_IS_CONNECTIVITY_PLAN_SELECTED,
    payload: {
      selected: selected
    }
  };
};
exports.setIsConnectivityPlanSelected = setIsConnectivityPlanSelected;
var setSlidersValues = function setSlidersValues(values) {
  return {
    type: SET_SLIDERS_VALUES,
    payload: values
  };
};
exports.setSlidersValues = setSlidersValues;
var clearSlidersValues = function clearSlidersValues() {
  return {
    type: CLEAR_SLIDERS_VALUES
  };
};
exports.clearSlidersValues = clearSlidersValues;